import { RouteEditTab } from "../../RouteEditTab";
import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";
import { FtlRouteViewModel } from "../../../ViewModel/FtlRouteViewModel";

const getSpdrsForList = (
  routeEditTabSelected: RouteEditTab,
  spdrs: Array<SpdrClientViewModel> | undefined,
  FTLRoutes?: Array<FtlRouteViewModel>
) => {
  switch (routeEditTabSelected) {
    case RouteEditTab.Ftl:
      return getSpdrsForFtlView(spdrs);
    case RouteEditTab.Ltl:
      return getSpdrsForLtlView(spdrs, FTLRoutes);
    default:
      throw new Error(
        `getSpdrs not implemented for RouteEditTab ${routeEditTabSelected}`
      );
  }
};

const getSpdrsForFtlView = (spdrs?: Array<SpdrClientViewModel>) => {
  return spdrs;
};

const getSpdrsForLtlView = (
  spdrs?: Array<SpdrClientViewModel>,
  FTLRoutes?: Array<FtlRouteViewModel>
) => {
  if (!spdrs) {
    return [];
  }

  const list: Array<SpdrClientViewModel> = [];

  // Alle SPDRS, die nicht einer Route zugeordnet wurden
  addToListIfNotExists(list, getSpdrsWhichAreNotAssignedToRoute(spdrs));

  // Alle SPDRs, die dem Routen Typen FTL2 zugeordnet wurden
  addToListIfNotExists(list, getSpdrsWhichAreFtl2(spdrs, FTLRoutes));

  // Alle SPDRs, die dem Routen Typen Top-Up zugeordnet wurden und in der SPDR Liste ein ODC mit dem  Vermerkt „Unload“ definiert wurde.
  addToListIfNotExists(
    list,
    getSpdrsWhichAreTopupAndOdcUnload(spdrs, FTLRoutes)
  );

  return list;
};

const getSpdrsWhichAreNotAssignedToRoute = (
  spdrs?: Array<SpdrClientViewModel>
): Array<SpdrClientViewModel> =>
  spdrs?.filter((x) => x.UsedInFtlRoutes === 0) || [];

const addToListIfNotExists = (
  list: Array<SpdrClientViewModel>,
  newItems: Array<SpdrClientViewModel>
) => {
  newItems.forEach((newItem) => {
    const listSpdr = list.filter((x) => x.SpdrId === newItem.SpdrId);
    const missingInList = listSpdr.length === 0;
    if (!missingInList) {
      return;
    }

    list.push(newItem);
  });
};

const getSpdrsWhichAreFtl2 = (
  spdrs?: Array<SpdrClientViewModel>,
  FTLRoutes?: Array<FtlRouteViewModel>
) => {
  if (!spdrs) {
    return [];
  }

  let list: Array<SpdrClientViewModel> = [];

  const ftl2Routes = FTLRoutes?.filter((x) => x.RouteType === "FTL2");
  ftl2Routes?.forEach((route) => {
    if (!route.SpdrsOnThisRoute) {
      return;
    }

    route.SpdrsOnThisRoute.forEach((spdrOnThisRoute) => {
      const projectSpdr = spdrs?.filter(
        (x) => x.SpdrId === spdrOnThisRoute.SpdrId
      );
      list = list.concat(projectSpdr);
    });
  });
  return list;
};

const getSpdrsWhichAreTopupAndOdcUnload = (
  spdrs?: Array<SpdrClientViewModel>,
  FTLRoutes?: Array<FtlRouteViewModel>
) => {
  if (!spdrs) {
    return [];
  }

  let list: Array<SpdrClientViewModel> = [];

  const topUpRoutes = FTLRoutes?.filter((x) => x.RouteType === "Top-Up");
  topUpRoutes?.forEach((route) => {
    if (!route.SpdrsOnThisRoute) {
      return;
    }

    route.SpdrsOnThisRoute.forEach((spdrOnThisRoute) => {
      if (!spdrOnThisRoute) {
        return;
      }

      const odcs = spdrOnThisRoute.ODCs;
      if (!odcs || odcs.length === 0) {
        return;
      }

      odcs.forEach((spdrWithOdcMark) => {
        if (spdrWithOdcMark.LoadType !== "Unload") {
          return;
        }

        const projectSpdr = spdrs?.filter(
          (x) => x.SpdrId === spdrOnThisRoute.SpdrId
        );
        list = list.concat(projectSpdr);
      });
    });
  });

  return list;
};

export default getSpdrsForList;
